import "bootstrap/dist/js/bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./src/styles/global.css";
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;
